// styles/global.js
import { getConfig } from '@tcs/create-account/utils/configService';
import css from 'styled-jsx/css';

export const getStyles = async () => {
  const config = await getConfig();
  const basePath = config.REACT_APP_BASE_PATH;

  return css.global`
    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 700;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 700;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 500;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 500;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 400;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 400;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 300;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 300;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 200;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 200;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    #create-account {
      padding-bottom: 40px;
    }

    #create-account .iras-a-7steps-plugin-section-process {
      padding-top: 40px;
    }

    #create-account .iras-a-loading-spinner {
      min-height: 50vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    body {
      background: white;
    }

    hr {
      margin: 1rem 0;
      color: inherit;
      background-color: currentColor;
      border: 0;
      opacity: 0.25;
    }
    hr:not([size]) {
      height: 1px;
    }
    .h1,
    .h2,
    .h3,
    .h4,
    .h5,
    .h6,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0;
      margin-bottom: 0.5rem;
      font-weight: 300;
      line-height: 1.2;
    }
    .h1,
    h1 {
      font-size: calc(1.385rem + 1.62vw);
    }
    @media (min-width: 1200px) {
      .h1,
      h1 {
        font-size: 2.6rem;
      }
    }
    .h2,
    h2 {
      font-size: calc(1.325rem + 0.9vw);
    }
    @media (min-width: 1200px) {
      .h2,
      h2 {
        font-size: 2rem;
      }
    }
    .h3,
    h3 {
      font-size: calc(1.3rem + 0.6vw);
    }
    @media (min-width: 1200px) {
      .h3,
      h3 {
        font-size: 1.75rem;
      }
    }
    .h4,
    h4 {
      font-size: calc(1.275rem + 0.3vw);
    }
    @media (min-width: 1200px) {
      .h4,
      h4 {
        font-size: 1.5rem;
      }
    }
    .h5,
    h5 {
      font-size: 1.25rem;
    }
    .h6,
    .iras-a-create-account p {
      font-size: 1rem;
    }
    .iras-a-create-account footer a {
      color: inherit;
      font-weight: 300;
    }
    footer {
      text-rendering: optimizeLegibility;
      -moz-osx-font-smoothing: grayscale;
      -webkit-font-smoothing: antialiased;
    }
  `;
};
